module.exports = __webpack_public_path__ + "assets/images/usage.186fb7413abaed944798769e4dcba241.svg";